class SearchAutocomplete {
    constructor() {
        this.suggestions = [
            'leggings', 'pants', 'tops', 'bras', 'socks', 'shorts',
            'tank tops', 'sports bras', 'yoga pants', 'athletic wear',
            'workout clothes', 'fitness apparel', 'activewear', 'gym clothes',
            'running shorts', 'compression leggings', 'athletic shorts',
            'sports tops', 'fitness leggings', 'workout leggings'
        ];
        this.currentFocus = -1;
        this.searchInput = document.getElementById('Search-In-Modal');

        if (!this.searchInput) {
            console.log('Search input not found');
            return;
        }

        this.init();
    }

    init() {
        this.createAutocompleteContainer();

        // Event listeners
        this.searchInput.addEventListener('input', () => this.handleInput());
        this.searchInput.addEventListener('keydown', (e) => this.handleKeydown(e));
        this.searchInput.addEventListener('blur', () => setTimeout(() => this.closeAutocomplete(), 150));
        document.addEventListener('click', (e) => {
            if (!this.searchInput.contains(e.target) && !this.autocompleteList.contains(e.target)) {
                this.closeAutocomplete();
            }
        });
    }

    createAutocompleteContainer() {
        this.autocompleteList = document.createElement('div');
        this.autocompleteList.className = 'search-autocomplete-list';

        const searchContainer = this.searchInput.closest('.field');
        if (searchContainer) {
            searchContainer.style.position = 'relative';
            searchContainer.appendChild(this.autocompleteList);
        }
    }

    handleInput() {
        const value = this.searchInput.value.toLowerCase();

        if (value.length < 2) {
            this.closeAutocomplete();
            return;
        }

        const filteredSuggestions = this.suggestions.filter(suggestion =>
            suggestion.toLowerCase().includes(value)
        );

        if (filteredSuggestions.length > 0) {
            this.showSuggestions(filteredSuggestions, value);
        } else {
            this.closeAutocomplete();
        }
    }

    showSuggestions(suggestions, searchTerm) {
        this.autocompleteList.innerHTML = '';

        suggestions.forEach((suggestion, index) => {
            const item = document.createElement('div');
            item.className = 'search-autocomplete-item';

            // Highlight matching part
            const regex = new RegExp(`(${searchTerm})`, 'gi');
            item.innerHTML = suggestion.replace(regex, '<strong>$1</strong>');

            item.addEventListener('click', () => this.selectSuggestion(suggestion));
            item.addEventListener('mouseenter', () => {
                this.removeActive();
                item.classList.add('active');
            });
            item.addEventListener('mouseleave', () => item.classList.remove('active'));

            this.autocompleteList.appendChild(item);
        });

        this.autocompleteList.style.display = 'block';
        this.currentFocus = -1;
    }

    handleKeydown(event) {
        const items = this.autocompleteList.querySelectorAll('.search-autocomplete-item');

        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                this.currentFocus++;
                this.addActive(items);
                break;
            case 'ArrowUp':
                event.preventDefault();
                this.currentFocus--;
                this.addActive(items);
                break;
            case 'Enter':
                event.preventDefault();
                if (this.currentFocus > -1 && items[this.currentFocus]) {
                    this.selectSuggestion(items[this.currentFocus].textContent);
                }
                break;
            case 'Escape':
                this.closeAutocomplete();
                break;
        }
    }

    addActive(items) {
        this.removeActive();
        if (this.currentFocus >= items.length) this.currentFocus = 0;
        if (this.currentFocus < 0) this.currentFocus = items.length - 1;
        if (items[this.currentFocus]) {
            items[this.currentFocus].classList.add('active');
        }
    }

    removeActive() {
        this.autocompleteList.querySelectorAll('.search-autocomplete-item')
            .forEach(item => item.classList.remove('active'));
    }

    selectSuggestion(suggestion) {
        this.searchInput.value = suggestion;
        this.closeAutocomplete();
        this.searchInput.focus();
    }

    closeAutocomplete() {
        this.autocompleteList.style.display = 'none';
        this.currentFocus = -1;
    }
}

// Initialize autocomplete when DOM is loaded
document.addEventListener('DOMContentLoaded', () => new SearchAutocomplete());